import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { useId } from '@react-aria/utils';
import { Stack } from "../Stack";
import { textStyles } from "../Text";
import { TextFieldHelp, TextFieldLabel } from "../TextField";
import { sharedInputContainerStyles, sharedInputStyles, textFieldSizes } from "../TextField/TextField.styles";
import React from 'react';
import styled, { css } from 'styled-components';
import { theme } from "../../theme";
export function NumberField(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      label = _ref.label,
      idProp = _ref.id,
      helpText = _ref.helpText,
      placeholder = _ref.placeholder,
      _ref$dense = _ref.dense,
      dense = _ref$dense === void 0 ? false : _ref$dense,
      other = _objectWithoutProperties(_ref, ["size", "label", "id", "helpText", "placeholder", "dense"]);

  var id = useId(idProp);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Stack, {
    gap: 4
  }, label && /*#__PURE__*/React.createElement(TextFieldLabel, {
    htmlFor: id
  }, label), /*#__PURE__*/React.createElement(StyledNumberField, _extends({
    id: id,
    "aria-label": label ? undefined : placeholder,
    type: "number",
    $size: size,
    $dense: dense
  }, other))), helpText && /*#__PURE__*/React.createElement(TextFieldHelp, {
    paddingLeft: "px",
    paddingTop: 4
  }, helpText));
}
var hideArrows = css(["&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type='number']{-moz-appearance:textfield;}"]);
var StyledNumberField = styled.input.withConfig({
  displayName: "NumberField__StyledNumberField",
  componentId: "vapor__sc-13wdop9-0"
})(["", ";", ";", ";", ";", ";text-align:center;", ""], sharedInputStyles, textStyles.primary, sharedInputContainerStyles, hideArrows, function (p) {
  return textFieldSizes[p.$size];
}, function (p) {
  return p.$dense && "\n    padding-left: ".concat(theme.spaces[4], ";\n    padding-right: ").concat(theme.spaces[4], ";\n  ");
});